export default {
	phoneBlocker: {
		message: "Diese Seite funktioniert nicht auf dem Smartphone.",
		backToDashboard: "Zurück zum Dashboard",
	},
};
